var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "form" } },
    [
      _c(
        "div",
        { staticClass: "container-cadastro" },
        [
          _c(
            "div",
            { attrs: { id: "passos" } },
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    active: _vm.passoAtivo,
                    "finish-status": "success",
                    simple: "simple"
                  }
                },
                [
                  _c("el-step", {
                    attrs: { title: "Informar dados do Ofício de Matrícula" }
                  }),
                  _c("el-step", {
                    attrs: { title: "Confirmar Ofício de Matrícula" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { id: "corpo" } },
            [
              _vm.passoAtivo === 0
                ? _c("informar-dados", { attrs: { oficio: _vm.oficio } })
                : _vm._e(),
              _vm.passoAtivo === 1
                ? _c("confirmar-matricula", {
                    attrs: { oficio: _vm.oficio },
                    on: { getBytesPdf: _vm.getBytesPdf }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("app-buttons-cadastro", {
            attrs: {
              isPrimeiroPasso: false,
              isUltimoPasso: _vm.ultimoPasso,
              showButtonProximo: !_vm.ultimoPasso,
              showButtonCancelar: false,
              showButtonSalvar: _vm.passoAtivo === 0,
              showButtonDownload: _vm.passoAtivo !== 0
            },
            on: {
              proximo: _vm.proximo,
              finalizar: _vm.finalizar,
              salvar: _vm.salvar,
              voltar: _vm.voltar,
              download: _vm.download
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c790a95e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c790a95e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gp/components/matricula/EmissaoMatricula.vue
// module id = null
// module chunks = 